import { createTheme, ThemeOptions } from '@mui/material/styles';
import 'dayjs/locale/pt-br';
import { ptBR } from '@mui/x-date-pickers/locales';

const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: { main: '#0F1A2A', contrastText: '#fff' },
    secondary: { main: '#FF4081', contrastText: '#fff' },
    background: { default: '#f3f4f6', paper: '#ffffff' },
    text: { primary: '#0F1A2A', secondary: '#555' },
  },

  // -----------------------------------------------------------
  // TIPOGRAFIA GLOBAL (compacta porém acessível)
  // -----------------------------------------------------------
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    htmlFontSize: 15,                      // leve redução geral (~93%)
    body1: { fontSize: '0.92rem' },
    body2: { fontSize: '0.84rem' },
    button: {
      fontSize: '0.80rem',
      fontWeight: 600,
      textTransform: 'none',
    },
  },

  shape: { borderRadius: 6 },

  components: {
    // -----------------------------------------------------------
    // INPUTS COMPACTADOS (TextField / Select / Autocomplete)
    // -----------------------------------------------------------
    MuiInputBase: {
  styleOverrides: {
    // mantém suas overrides existentes...
    input: {
      fontSize: '0.80rem',
      // padding padrão para a maioria dos inputs
      padding: '4px 8px',
      // ajustes específicos para date inputs nativos
      // NOTA: o selector abaixo aplica-se ao input dentro do InputBase
      '&[type="date"]': {
        paddingTop: '8px',    // aumenta espaço superior para o label flutuar
        paddingBottom: '6px', // garante que o valor não fique cortado
      },
    },
  },
},
   MuiOutlinedInput: {
  styleOverrides: {
    input: {
      // garantindo que o date também receba este padding
      '&[type="date"]': {
        padding: '8px 10px 6px 10px',
      },
    },
    root: {
      // altura mínima para inputs (ajusta-se ao compacto)
      minHeight: 40,
    },
  },
},
MuiInputLabel: {
  styleOverrides: {
    root: {
      fontSize: '1.05rem',                        // ⬆ AUMENTADO (antes ~0.90/1.0)
      transform: 'translate(12px, 13px) scale(1)', // desce um pouco p/ não esmagar
    },
    shrink: {
      fontSize: '0.92rem',                          // ⬆ também maior no shrink
      transform: 'translate(12px, -4px) scale(0.86)',// reduz menos, fica mais legível
      background: '#ffffff',                        // evita sobrepor bordas
      padding: '0 4px',
      zIndex: 2,
    }
  }
},

    // -----------------------------------------------------------
    // BUTTONS COMPACTADOS
    // -----------------------------------------------------------
    MuiButton: {
      styleOverrides: {
        root: {
          height: 32,
          padding: '4px 10px',
          borderRadius: 8,
          boxShadow: 'none',
        },
      },
    },

    // -----------------------------------------------------------
    // PAPERS + ESPAÇAMENTO MAIS ENXUTO
    // -----------------------------------------------------------
    MuiTextField: { styleOverrides: { root: { marginBottom: 10 } } },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
        },
      },
    },
  },
};

const tema = createTheme(themeOptions, ptBR);
export default tema;
